import React, { useEffect } from 'react';

import Pagination from '~components/atoms/Pagination';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

const InventoryTransactionPaginator = () => {
    const isLoading = useAppSelector(state => state.gold.loadings.getInventoryTransactionListing);
    const { index, maxIndex } = useAppSelector(state => state.gold.goldInventory.inventoryTransactionListing);

    const dispatch = useAppDispatch();

    const setIndex = (newIndex: number) => {
        if (isLoading) return;

        dispatch(combinedActions.goldSetInventoryTransactionListingIndex({ index: newIndex }));
    };

    // if maxIndex is lower then index reset index to 0
    useEffect(() => {
        if (index > maxIndex) {
            setIndex(0);
        }
    }, [maxIndex]);

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };
    const handleOnNext = () => {
        if (index < maxIndex) setIndex(index + 1);
    };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex >= 0 ? maxIndex : 0);

    return (
        <Pagination
            currentPage={index}
            maxPage={maxIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default InventoryTransactionPaginator;
